module.exports = __webpack_public_path__ + "img/en_logo_select.4a7ba1f9.png";